<template>
  <div class="glass-spinner" :class="[`size-${size}`, `variant-${variant}`]">
    <svg viewBox="0 0 50 50" class="spinner-svg">
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke-width="4"
        stroke-linecap="round"
        class="spinner-circle"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'GlassSpinner',
  props: {
    size: {
      type: String,
      default: 'md',
      validator: (val) => ['sm', 'md', 'lg', 'xl'].includes(val)
    },
    variant: {
      type: String,
      default: 'primary'
    }
  }
};
</script>

<style scoped>
.glass-spinner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.size-sm {
  width: 1rem;
  height: 1rem;
}

.size-md {
  width: 2rem;
  height: 2rem;
}

.size-lg {
  width: 3rem;
  height: 3rem;
}

.size-xl {
  width: 4rem;
  height: 4rem;
}

.spinner-svg {
  width: 100%;
  height: 100%;
  animation: rotate 1.4s linear infinite;
}

.spinner-circle {
  stroke-dasharray: 80, 200;
  stroke-dashoffset: 0;
  animation: dash 1.4s ease-in-out infinite;
}

.variant-primary .spinner-circle {
  stroke: var(--theme-primary, var(--color-success));
}

.variant-secondary .spinner-circle {
  stroke: var(--color-text-muted);
}

.variant-success .spinner-circle {
  stroke: var(--color-success);
}

.variant-danger .spinner-circle {
  stroke: var(--color-danger);
}

.variant-warning .spinner-circle {
  stroke: var(--color-warning);
}

.variant-info .spinner-circle {
  stroke: var(--color-info);
}

.variant-light .spinner-circle {
  stroke: #ffffff;
}

.variant-dark .spinner-circle {
  stroke: #1a1a1a;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124;
  }
}
</style>
